import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { CreateOrEditChild } from '../../createOrEditChildIdeaMass'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<CreateOrEditChidInspiration {...props} visible container={div} />, div)
  })
}

// parentId={info.id}
// currentRole={info?.loginUserInfo?.role}

const CreateOrEditChidInspiration = (props) => {
  const { visible, onChange, onCancel, onOk, parentId, auth, inspirationId, onDelete, currentRole, isCreate } = props
  const [_visible, set_Visible] = useState(visible)

  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }

  return <CreateOrEditChild
    visible={_visible}
    setVisible={set_Visible}
    onChange={onChange}
    parentId={parentId}
    inspirationId={inspirationId}
    onDelete={onDelete}
    currentRole={currentRole}
    isCreate={isCreate}
    auth={auth}
    onCancel={_cancel}
    onOk={onOk}
  />
}
